import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ec91416"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "人员统计", -1))
const _hoisted_4 = { class: "el-dropdown-link point" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("在保")
const _hoisted_8 = { class: "block-content" }
const _hoisted_9 = {
  id: "chart-level",
  style: {"height":"350px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onIsActive(false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onIsActive(true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.onlyActive ? '在保' : '全部') + " ", 1),
            _hoisted_5
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createVNode(_component_el_empty, null, null, 512), [
        [_vShow, _ctx.isEmpty]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
        [_vShow, !_ctx.isEmpty]
      ])
    ])
  ]))
}